"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20TransferableReceivable__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "_paymentProxyAddress",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "feeAddress",
                type: "address",
            },
        ],
        name: "TransferWithReferenceAndFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "receivableTokenId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
        ],
        name: "TransferableReceivablePayment",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "erc20Addr",
                type: "address",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "receivableTokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "feeAddress",
                type: "address",
            },
        ],
        name: "payOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paymentProxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "receivableInfoMapping",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "receivableTokenIdMapping",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class ERC20TransferableReceivable__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(name, symbol, _paymentProxyAddress, overrides) {
        return super.deploy(name, symbol, _paymentProxyAddress, overrides || {});
    }
    getDeployTransaction(name, symbol, _paymentProxyAddress, overrides) {
        return super.getDeployTransaction(name, symbol, _paymentProxyAddress, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20TransferableReceivable__factory = ERC20TransferableReceivable__factory;
ERC20TransferableReceivable__factory.bytecode = _bytecode;
ERC20TransferableReceivable__factory.abi = _abi;
